import React from 'react';

import {
  Box,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
} from '@mui/material';

import { CapsulesTableHead } from 'new/modules/settings/capsules/screens/CapsulesSettingsScreen/components/CapsulesTable/CapsulesTableHead';

import dataRowStyles from 'new/modules/settings/capsules/screens/CapsulesSettingsScreen/components/CapsulesTable/CapsulesTableDataRow/CapsulesTableDataRow.module.scss';
import styles from 'new/modules/settings/capsules/screens/CapsulesSettingsScreen/components/CapsulesTable/CapsulesTable.module.scss';

const SKELETON_ROW_COUNT = 5;

export const CapsulesTableSkeleton: React.FC = () => {
  const skeletonRows = Array.from({ length: SKELETON_ROW_COUNT });

  return (
    <TableContainer
      component={Paper}
      elevation={0}
      className={styles.tableContainer}
      aria-busy="true"
      aria-label="Loading capsules"
    >
      <Table stickyHeader>
        <CapsulesTableHead />
        <TableBody>
          {skeletonRows.map((_, index) => (
            <TableRow key={index} className={dataRowStyles.tableRowStatic}>
              <TableCell className={dataRowStyles.dataCell}>
                <Box display="flex" flexDirection="column" gap={0.5}>
                  <Skeleton animation="wave" variant="text" width="60%" height={20} />
                  <Skeleton animation="wave" variant="text" width="40%" height={16} />
                </Box>
              </TableCell>
              <TableCell className={dataRowStyles.dataCell}>
                <Skeleton animation="wave" variant="text" width="45%" height={20} />
              </TableCell>
              <TableCell className={dataRowStyles.actionsCell}>
                <Skeleton
                  animation="wave"
                  variant="circular"
                  width={24}
                  height={24}
                  sx={{ margin: '0 0 0 8px' }}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
